import { render, staticRenderFns } from "./RotatesManagerForm.vue?vue&type=template&id=ce15b4e6&"
import script from "./RotatesManagerForm.vue?vue&type=script&lang=ts&"
export * from "./RotatesManagerForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports